import example from '../assets/tutorials/example.mp4'
import pic1 from '../assets/pic1.jpg';
import pic2 from '../assets/pic2.jpg';
import pic3 from '../assets/pic3.jpg';
import pic4 from '../assets/pic4.jpg';
import pic5 from '../assets/pic5.jpg';
import pic6 from '../assets/pic6.jpg';
import { generateColors } from './helpers';

type WelcomeCard = {
  id: number;
  title: string;
  description: string;
  image: string;
  action: string;
  link: string;
}

export const cards: WelcomeCard[] = [
  {
    id: 1,
    title: "Tableau de bord",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic6,
    action: "Get Started",
    link: "/app/dashboard"
  },
  {
    id: 2,
    title: "Paramétrage tarifaire",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic1,
    action: "Get Started",
    link: "/app/data-controller"
  },
  {
    id: 3,
    title: "Administration",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic2,
    action: "Get Started",
    link: "/app/audit"
  },
  {
    id: 4,
    title: "Dérogations tarifaires",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic3,
    action: "Get Started",
    link: "/app/derogation"
  },
  {
    id: 5,
    title: "Etudes et simulations",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic4,
    action: "Get Started",
    link: "/app/app/simulations/input"
  },
  {
    id: 6,
    title: "Contact et support",
    description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    image: pic5,
    action: "Get Started",
    link: "/app/welcome"
  }
]

export type InfoAssetType = {
  type: 'image' | 'video';
  source: string;
}

export type InfoElement = {
  origin: string;
  asset: InfoAssetType | null;
  description: string;
  title: string;
}

export const infos: InfoElement[] = [
  {
    title: 'Info référentiels',
    origin: 'repositories',
    asset: { type: 'video', source: example },
    description: "<p>Cette rubrique permet d'importer les données d'entrée via le bouton 'Importer'.</p> <ul> <li>Une fois importées, les données sont affichées dans la partie Input et les résultats obtenus sont affichés dans la partie résultat.</li> <li>Cette rubrique permet également de télécharger une ou plusieurs tables de résultats à travers le bouton Télécharger</li> </ul>"
  },
  {
    title: 'Info à propos DMC',
    origin: 'data-controller',
    asset: { type: 'image', source: 'https://new-axa-prod.s3.eu-west-1.amazonaws.com/axa-morocco/ZTNhYjQwMmYtNTVmNy00NzExLTk0ZDYtNDcxOTcxMzIzMmIw_i00njlhlwewndqtmtu1nzlhodvim2q3_ogrmowe5nzctntziny00zty3lwiyndityzlizwy3njkwmgiy_57619d38-3772-491d-9257-19471cb337c1_banner-auto-f-281280x81429-p2.png' },
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum vitae modi culpa ipsa ratione, excepturi aut temporibus? Quo debitis fugiat, dignissimos, alias possimus sed commodi quibusdam veritatis beatae dolores dolor.'
  },
  {
    title: 'Info à propos les versions',
    origin: 'versions',
    asset: { type: 'video', source: 'https://new-axa-prod.s3.eu-west-1.amazonaws.com/axa-morocco/YWNlZjhjOWMtMGE2ZS00MmMyLWEzOGQtMmU0YWJhMGY4NGNj_ngi4nznin2qtmtzjzs00yzg3lwiwodytnjllmwjmody2ogyw_nzm3odawmzetyzzlyi00n2m3lwizowqtmdm1nta5zdiyodhl_bb2bdd1d-1d54-4bbb-91bb-9971c14c197f_auto33.png' },
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum vitae modi culpa ipsa ratione, excepturi aut temporibus? Quo debitis fugiat, dignissimos, alias possimus sed commodi quibusdam veritatis beatae dolores dolor.'
  },
  {
    title: 'Info sur le tableau de bord',
    origin: 'dashboard',
    asset: { type: 'image', source: 'https://new-axa-prod.s3.eu-west-1.amazonaws.com/axa-morocco/YzJmYTk5MTMtM2JhZi00ODdmLThkZTktYjhlNTc0NTU0NTQy_rmlthjmtqtymuwotgznmyzzjzj_ngm3yti2mditnwm3zc00ndyzltkynwmtmwrkndqyndgxnwnm_69ed7d76-6e17-4109-a989-36ce9a68ff3e_banner-mihnassur-f-281280x81429-p1.png' },
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum vitae modi culpa ipsa ratione, excepturi aut temporibus? Quo debitis fugiat, dignissimos, alias possimus sed commodi quibusdam veritatis beatae dolores dolor.'
  },
  {
    title: 'Configuration tarifaire',
    origin: 'pricing-config',
    asset: { type: 'video', source: 'https://new-axa-prod.s3.eu-west-1.amazonaws.com/axa-morocco/YzJmYTk5MTMtM2JhZi00ODdmLThkZTktYjhlNTc0NTU0NTQy_rmlthjmtqtymuwotgznmyzzjzj_ngm3yti2mditnwm3zc00ndyzltkynwmtmwrkndqyndgxnwnm_69ed7d76-6e17-4109-a989-36ce9a68ff3e_banner-mihnassur-f-281280x81429-p1.png' },
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum vitae modi culpa ipsa ratione, excepturi aut temporibus? Quo debitis fugiat, dignissimos, alias possimus sed commodi quibusdam veritatis beatae dolores dolor.'
  },

]

export const versions = [
  {
    "id": 1,
    "libelle": "Version 1.0",
    "description": "Initial version",
    "status": "En cours",
    "created_at": "2023-01-15",
    "effected_at": "2023-02-01"
  },
  {
    "id": 2,
    "libelle": "Version 1.1",
    "description": "Bug fixes and performance improvements",
    "status": "En cours",
    "created_at": "2023-02-20",
    "effected_at": "2023-03-05"
  },
  {
    "id": 3,
    "libelle": "Version 2.0",
    "description": "Major update with new features",
    "status": "En cours",
    "created_at": "2023-04-10",
    "effected_at": "2023-05-01"
  },
  {
    "id": 4,
    "libelle": "Version 2.1",
    "description": "Security patch release",
    "status": "En cours",
    "created_at": "2023-06-15",
    "effected_at": "2023-07-01"
  },
  {
    "id": 5,
    "libelle": "Version 3.0",
    "description": "Revamped user interface",
    "status": "En cours",
    "created_at": "2023-08-20",
    "effected_at": "2023-09-01"
  }
]

export const structureColors = [
  "#027180",
  "#914146",
  "#8a7333"
]

export const subStructureColors = [
  "#138636",
  "#4976ba",
  "#ffbc11"
]

export const ROLLBACK_CANCEL_MODE: { mode: string } = { mode: "cancel" }

export const colors = generateColors(4)
export const borderColors = colors.map(color => color.replace('hsl', 'hsla').replace(')', ', 1)'))

export const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const
    }
  },
}

export const lineOptions = {
  ...commonOptions,
  plugins: {
    ...commonOptions.plugins,
    datalabels: {
      display: false
    }
  }
}

export const barOptions = {
  ...commonOptions,
  plugins: {
    ...commonOptions.plugins,
    datalabels: {
      color: '#fff'
    }
  }
}

export const workflowInputColumns: { title: string, dataIndex: string, key: string }[] = [
  {
    title: "Variable",
    dataIndex: "variable",
    key: "variable"
  },
  {
    title: "Value",
    dataIndex: "value",
    key: "value"
  },
]
